import { VFC, useState, useCallback, useEffect } from "react";
import {
  Modal,ModalOverlay,ModalContent,ModalHeader,ModalCloseButton,ModalBody,ModalFooter,
  FormControl,FormLabel,FormErrorMessage,Input,Text,Textarea,
} from "@chakra-ui/react";
import { PrimaryButton } from "../../atoms/button/PrimaryButton";
// import { useLoginUser } from "../../../hooks/providers/useLoginUserProvider";
import { ErrorDialog } from "../../organisms/modal/ErrorDialog";
import { useIssue } from '../../../hooks/useIssue';

type Props = {
  groupName: string;
  groupId: string;
  updateItem: string;
  updateItemName: string;
  setUpdateItem: (val:string)=>void;  // ダイアログ閉じる用
  value: string;
  setValue: (val:string)=>void;
};

export const UpdateIssueGroupDialog: VFC<Props> = (props) => {
  const { groupName, groupId, updateItem, updateItemName, value, setUpdateItem, setValue } = props;
  const { updateIssueGroup, updateIssueGroupResult, executing, errObj } = useIssue();
  const [ page, setPage ] = useState('input');
  const [ isError, setIsError ] = useState(true);
  const [ closeFlag, setCloseFlag ] = useState(false);
  const [ tmpVal, setTmpVal ] = useState(value);
  
  // 入力動作
  const changeVal = (event: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement>) => {
    const val = event.target.value;
    
    // 更新有無チェック＆長さチェック
    if( val === value || val.length > 2000 ) {
      setIsError(true);
    }else{
      setIsError(false);
    }
    setTmpVal(val);
  }
  
  // 更新実行
  const updateVal = useCallback(() => {
    updateIssueGroup(groupName,groupId,updateItem,tmpVal);
  },[tmpVal]);
  
  // 更新結果取得
  useEffect(() => {
    if( updateIssueGroupResult === 'succeed' ){
      setValue(tmpVal);
      setPage('end');
    }else if( closeFlag ){
      setUpdateItem('');
    }
  }, [updateIssueGroupResult,closeFlag]);
  
  return (
    <>
      {errObj && !closeFlag ? (
        <ErrorDialog errTitle={`${updateItemName}更新エラー`} errObj={errObj} opeErrMes='' setCloseFlag={setCloseFlag} />
      
      ) : (
        <Modal
          isOpen={true}
          onClose={()=>setUpdateItem('')}
          motionPreset="slideInBottom"
          autoFocus={false}
          size="2xl"
          isCentered
          closeOnOverlayClick={false}
          allowPinchZoom
        >
          <ModalOverlay />
          
          {page === 'input' ? (
            <ModalContent pb={2}>
              <ModalHeader>{updateItemName + '（更新入力）'}</ModalHeader>
              <ModalCloseButton />
              <ModalBody mx={6}>
                <FormControl isInvalid={isError} marginTop="10px">
                  <FormLabel>{updateItemName}</FormLabel>
                  {updateItem === 'comment' ? (
                    <Textarea id="item" onChange={(event)=>changeVal(event)} value={tmpVal} bgColor="white" />
                  ) : (
                    <Input id="item" onChange={(event)=>changeVal(event)} value={tmpVal} bgColor="white" />
                  )}
                  {isError && (
                    <FormErrorMessage>値を変更してください</FormErrorMessage>
                  )}
                </FormControl>
                
              </ModalBody>
              <ModalFooter>
                <PrimaryButton size="md" type="ng" onClick={()=>setUpdateItem('')} isLoading={executing}>閉じる</PrimaryButton>
                <Text>{'　'}</Text>
                <PrimaryButton size="md" type="ok" onClick={()=>setPage('confirm')} disabled={isError} isLoading={executing}>確認</PrimaryButton>
              </ModalFooter>
            </ModalContent>
          
          ) : page === 'confirm' ? (
            <ModalContent pb={2} bgColor="blue.50">
              <ModalHeader>{updateItemName + '(更新確認）'}</ModalHeader>
              <ModalCloseButton />
              <ModalBody mx={6}>
                <FormControl marginTop="10px">
                  <FormLabel>{updateItemName}</FormLabel>
                  {updateItem === 'comment' ?
                  <Textarea id="item" value={tmpVal} bgColor="white" isReadOnly={true} />
                  :
                  <Input id="item" value={tmpVal} bgColor="white" isReadOnly={true} />
                  }
                </FormControl>
                
              </ModalBody>
              <ModalFooter>
                <PrimaryButton size="md" type="ng" onClick={()=>setPage('input')} isLoading={executing}>戻る</PrimaryButton>
                <Text>{'　'}</Text>
                <PrimaryButton size="md" type="ok" onClick={updateVal} isLoading={executing}>更新実行</PrimaryButton>
              </ModalFooter>
            </ModalContent>
                
          ) : page === 'end' && (
            <ModalContent pb={2}>
              <ModalHeader>{updateItemName + '（更新完了）'}</ModalHeader>
              <ModalCloseButton />
              <ModalBody mx={6}>
                <Text>更新を完了しました。</Text>
                
              </ModalBody>
              <ModalFooter>
                <PrimaryButton size="md" type="ok" onClick={()=>setUpdateItem('')} isLoading={executing}>閉じる</PrimaryButton>
              </ModalFooter>
            </ModalContent>
            
          )}
        </Modal>
      )}
    </>
  );
};

// // 添付ファイルのメンテナンス
// type Props2 = {
//   updateItem: string;
//   updateItemName: string;
//   setUpdateItem: (val:string)=>void;
//   attachList: attachObj[];
//   setAttachList: (list:attachObj[])=>void;
// };

// export const UpdateExpFileDialog: VFC<Props2> = (props) => {
//   const { updateItem, updateItemName, setUpdateItem, attachList, setAttachList } = props;
//   const { loginUser } = useLoginUser();
//   const { reportUpload, tempPath, reportDownload, setUpdatePost, updatePost, executing, errObj } = useDetail();
//   const [ page, setPage ] = useState('input');
//   const [ isErrorVal, setIsErrorVal ] = useState(false);
//   const [ uploading, setUploading ] = useState(false);
  
//   // アップロードボタンクリック
//   const onClickUploadButton = async () => {
//     if( loginUser.userKind ){
//       // 操作ログ登録
//       // OutputOpelog(loginUser.name, Functions.GROUP_UPDATE, Operations.REPORT_UP, "GROUP_NAME#" + groupName);
//     }
//     // file取得
//     const [fileHandle] = await window.showOpenFilePicker({ multiple: true });
//     setUploading(true);
//     const file = await fileHandle.getFile();
//     // file名取得
//     const fileName: string = file.name;
//     const fileReader = new FileReader();
//     fileReader.readAsDataURL(file);
//     fileReader.onload = () => {
//       // バイナリデータにエンコード
//       const base64 = fileReader.result as string;
//       // 先頭の余分な文字列を削除
//       const fileContext = base64.replace(/data:.*\/.*;base64,/, '');

//       // API実行
//       reportUpload(fileName, fileContext);

//       setUploading(false);
//     };
//   };

//   // 報告書リンククリック
//   const onClickReportLink = (
//     temp_path: string,
//     s3_path: string,
//     file_name: string
//   ) => {
//     if( loginUser.userKind ){
//       // 操作ログ登録
//       // OutputOpelog(loginUser.name, Functions.GROUP_UPDATE, Operations.REPORT_DL, "GROUP_NAME#" + groupName);
//     }
//     let dl_file = '';
//     if (temp_path !== '') {
//       dl_file = temp_path;
//     } else {
//       dl_file = s3_path;
//     }
//     reportDownload(dl_file, file_name);
//   };

//   // 削除ボタンクリック
//   const onClickDeleteButton = (obj: attachObj) => {
//     obj.mode = 'delete';
//     // state更新
//     setUpdatePost({ ...updatePost });
//   };
  
//   return (
//     <>
//       {errObj ? (
//         <ErrorDialog errTitle={`${updateItemName}更新エラー`} errObj={errObj} opeErrMes='' />
      
//       ) : (
//         <Modal
//           isOpen={true}
//           onClose={()=>setUpdateItem('')}
//           motionPreset="slideInBottom"
//           autoFocus={false}
//           size="2xl"
//           isCentered
//           closeOnOverlayClick={false}
//         >
//           <ModalOverlay />
          
//           {page === 'input' && (
//             <ModalContent pb={2} bgColor="blue.50">
//               <ModalHeader>{updateItemName + '（更新入力）'}</ModalHeader>
//               <ModalCloseButton />
//               <ModalBody mx={6}>
//                 <FormControl marginTop="10px">
//                   <>
//                     <FormLabel>{updateItemName}</FormLabel>
//                     {attachList.map(
//                       (obj, index) =>
//                         // modeがdeleteの場合は表示しない
//                         !(obj.mode === 'delete') && (
//                           <Flex key={index}>
//                             <Box mr="10px" mb="5px">
//                               <Link
//                                 onClick={() =>
//                                   onClickReportLink(
//                                     obj.temp_path,
//                                     obj.s3_path,
//                                     obj.file_name
//                                   )
//                                 }
//                                 textDecoration="underline"
//                               >
//                                 {obj.file_name}
//                               </Link>
//                             </Box>
//                             <DeleteIcon
//                               onClick={() => onClickDeleteButton(obj)}
//                             />
//                           </Flex>
//                         )
//                     )}
//                     <Box id="button-upload">
//                       <PrimaryButton
//                         onClick={onClickUploadButton}
//                         size="xs"
//                         isLoading={executing}
//                       >
//                         アップロード
//                       </PrimaryButton>
//                     </Box>
//                     {uploading && (
//                       <>
//                         <Center h="5vh">
//                           <Spinner color="teal.500" />
//                         </Center>
//                         <Box>※アップロード中</Box>
//                       </>
//                     )}
//                   </>
//                 </FormControl>
//               </ModalBody>
//               <ModalFooter>
//                 <PrimaryButton size="md" type="ng" onClick={()=>setUpdateItem('')} isLoading={executing}>閉じる</PrimaryButton>
//                 <Text>{''}</Text>
//                 <PrimaryButton size="md" type="ok" onClick={()=>setPage('confirm')} disabled={isErrorVal} isLoading={executing}>確認</PrimaryButton>
//               </ModalFooter>
//             </ModalContent>
            
//           )}
//         </Modal>
//       )}
//     </>
//   );
// };


          // ) : page === 'confirm' ? (
          //   <ModalContent pb={2} bgColor="blue.50">
          //     <ModalHeader>{updateItemName + '(更新確認）'}</ModalHeader>
          //     <ModalCloseButton />
          //     <ModalBody mx={6}>
          //       <FormControl marginTop="10px">
          //         <FormLabel>{updateItemName}</FormLabel>
          //         {updateItem === 'comment' ?
          //         <Textarea id="item" value={value} bgColor="white" isReadOnly={true} />
          //         :
          //         <Input id="item" value={value} bgColor="white" isReadOnly={true} />
          //         }
          //       </FormControl>
                
          //     </ModalBody>
          //     <ModalFooter>
          //       <PrimaryButton size="md" type="ng" onClick={()=>setPage('input')} isLoading={executing}>戻る</PrimaryButton>
          //       <Text>{''}</Text>
          //       <PrimaryButton size="md" type="ok" onClick={()=>setPage('end')} isLoading={executing}>更新実行</PrimaryButton>
          //     </ModalFooter>
          //   </ModalContent>
                
          // ) : page === 'end' && (
          //   <ModalContent pb={2}>
          //     <ModalHeader>{updateItemName + '（更新完了）'}</ModalHeader>
          //     <ModalCloseButton />
          //     <ModalBody mx={6}>
          //       <Text>更新を完了しました。</Text>
                
          //     </ModalBody>
          //     <ModalFooter>
          //       <PrimaryButton size="md" type="ok" onClick={()=>setUpdateItem('')} isLoading={executing}>ユーザ割り当てに戻る</PrimaryButton>
          //     </ModalFooter>
          //   </ModalContent>